<template>
  <div v-show="loaded" class="coupon-detail" :style="{ 'width': this.$store.state.clientWidth + 'px' }">
    <img class="coupon" :src="cover | filterPicture" />

    <div class="desc">
      <div>
        <h4 style="margin: 25px 0">{{ (type === 'PRIZE' && prizeReceiveType === 'express') ? '收货信息录入' : '核销码' }}</h4>
        <div v-if="code && !(type === 'PRIZE' && prizeReceiveType === 'express')" class="qrcode" ref="qrCodeUrl"></div>
        <div v-if="type === 'PRIZE' && prizeReceiveType === 'express'" class="ship-form">
          <div v-if="!submitSuccess">
            <van-field v-model="ship.name" label="收件人" :disabled="submitSuccess" />
            <van-field v-model="ship.phone" label="联系方式" type="number" :disabled="submitSuccess" />
            <van-field v-model="ship.address" label="收货地址" :disabled="submitSuccess" />
            <div class="ship-btn">
              <van-button @click="onPrizeSubmit" type="danger" size="normal" :disabled="!ship.name || !ship.phone || !ship.address">提交</van-button>
            </div>
          </div>
          <div v-else>
            <h6>
              <span style="width: 90px; display: inline-block">收件人：</span>{{ ship.name }}<br/>
              <span style="width: 90px; display: inline-block">联系方式：</span>{{ ship.phone }}<br/>
              <span style="width: 90px; display: inline-block">收货地址：</span>{{ ship.address }}
            </h6>
          </div>
        </div>
      </div>

      <div v-if="!(area.id === 'south' && type === 'PRIZE')">
        <h4>用户信息</h4>
        <h6>
          <span style="min-width: 70px; display: inline-block">姓名：</span>{{ name }}<br/>
          <span style="min-width: 70px; display: inline-block">手机号：</span>{{ phone }}<br v-if="card" />
          <span v-if="card" style="min-width: 70px; display: inline-block">证件号：</span>{{ card }}<br v-if="receiveAddress" />
          <span v-if="receiveAddress" style="min-width: 70px; display: inline-block">领取地址：</span>{{ receiveAddress }}
        </h6>
      </div>
      <h4>使用规则</h4>
      <h6 v-html="rule"></h6>
      <h4>免责声明</h4>
      <h6 v-html="illustration"></h6>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      loaded: false,

      id: '',
      name: '',
      phone: '',
      type: '',
      card: '',
      cover: '',
      rule: '',
      illustration: '',
      code: '',
      receiveAddress: '',

      ship: {
        name: '',
        phone: '',
        address: '',
      },

      submitSuccess: false,
      prizeReceiveType: null
    }
  },

  computed: {
    ...mapState({
      room: (state) => state.room
    })
  },

  activated () {
    document.getElementById('app').scrollIntoView()

    this.loaded = false
    this.submitSuccess = false
    this.prizeReceiveType = ''

    this.code = null
    this.card = null

    this.ship.name = ''
    this.ship.phone = ''
    this.ship.address = ''

    this.$nextTick(() => this.getDetail())
  },

  methods: {
    getDetail () {
      const couponId = this.$route.params.id
      
      if (!couponId) {
        return this.toast.fail('参数错误')
      }

      this.toast.loading({ duration: 0, message: '', forbidClick: true })

      
      this.request({ url: '/liveReceive/detail/' + couponId, data: {}}).then(res => {
        this.toast.clear()

        const coupon = res.result
        
        this.prizeReceiveType = coupon.liveRoomDetail.getPrizeWay
        this.type = coupon.type
        this.loaded = true

        if (coupon.type === 'PRIZE') {
          this.id = coupon.id
          this.cover = coupon.livePrizeDetail.imageDetail
          this.rule = coupon.livePrizeDetail.rules.replace(/\n|\r\n/g, '<br>')
          this.illustration = coupon.livePrizeDetail.illustration.replace(/\n|\r\n/g, '<br>')
          this.name = this.$store.state.user.realName
          this.phone = this.$store.state.user.mobile
          this.receiveAddress = coupon.receiveAddress

          if (this.prizeReceiveType === 'express') {
            if (coupon.shipInfo) {
              const shipArr = JSON.parse(coupon.shipInfo)

              this.ship.name = shipArr[0]
              this.ship.phone = shipArr[1]
              this.ship.address = shipArr[2]
              this.submitSuccess = true
            }
          } else if (this.prizeReceiveType === 'code') {
            this.code = coupon.useCode

            this.$nextTick(() => this.generateCode())
          }
        } else {
          this.id = coupon.id
          this.cover = coupon.liveVoucherDetail.imageDetail
          this.rule = coupon.liveVoucherDetail.rules.replace(/\n|\r\n/g, '<br>')
          this.illustration = coupon.liveVoucherDetail.detail.replace(/\n|\r\n/g, '<br>')
          this.code = coupon.useCode
          this.name = coupon.memberName
          this.phone = coupon.memberDetail.mobile
          this.card = coupon.memberPassport || coupon.memberIdcard

          this.$nextTick(() => this.generateCode())
        }
      })
    },

    generateCode () {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: window.location.origin + '/verification/' + this.id + '-' + encodeURIComponent(this.code),
        width: 150,
        height: 150,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },

    onPrizeSubmit () {
      this.toast.loading({ duration: 0, message: '', forbidClick: true })

      this.request({
        url: '/liveReceive/setShipInfo',
        data: { liveReceiveId: this.id, shipInfo: [this.ship.name, this.ship.phone, this.ship.address ] }
      }).then(res => {
        this.toast('提交表单成功')
        this.submitSuccess = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-detail {
  padding: 20px 17px;
  padding-bottom: calc(3.5rem * .5625 + .8rem);
  .coupon {
    width: 100%;
  }
  .desc {
    padding: 0 10px;
    h4 {
      margin: 20px 0 10px;
      font-size: 16px;
      color: #D8323F;
    }
    h6 {
      font-size: 14px;
      line-height: 26px;
      counter-reset: #4D4D4D;
    }
    .qrcode {
      display: block;
      margin: 0 auto 20px;
      width: 150px;
    }
  }
}
</style>

<style lang="scss">
.coupon-detail {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.ship-form {
  .van-field {
    display: flex;
    align-items: center;
    margin-bottom: .24rem;
    padding: 0 .25rem;
    height: .8rem;
    background: #F5F5F5;
    .van-field__label {
      height: .3rem;
      font-size: .3rem;
      line-height: .3rem;
      border-right: 1px solid #EB6757;
      color: #EB6757;
    }
    .van-cell__value {
      margin-left: .25rem;
    }
  }
  .ship-btn {
    margin: .5rem auto;
    text-align: center;
    button {
      width: 4.2rem;
      height: .88rem;
      border-radius: .4rem;
      background-color: #D7313F;
    }
  }
}
</style>